module.exports = __webpack_public_path__ + "img/business-plan.742a0fe9.svg";